import User from '@/models/User'
import * as MutationTypes from '../mutation-types'
import axios from 'axios'
import router from '../../router/index'
import { Notification } from 'element-ui'
import config from '../../config.js'
import dictionary from '../../store/dictionary'

const state = {
  // user: User.from(sessionStorage.token)
  userFirstname: '',
  userSurname: '',
  user: null,
  loadingUserScope: false,
  userScope: null,
  userScopeGr: null,
  activeRole: null
}

const mutations = {
  [MutationTypes.CHANGEDROLE] (...all) {
    state.activeRole = all[1].role
    state.user.activeRole = all[1].role
    all[1].rootState.showWorkingApplication = false
    all[1].rootState.activeLane = ''
    all[1].rootState.searchedAppHistory = []
    all[1].rootState.assignedApplications = []
    all[1].rootState.workingApplication = {}
    all[1].rootState.showWorkingApplication = false
    all[1].rootState.searchedApps = []
    all[1].rootState.searchVisible = false
    all[1].rootState.searchUniVisible = false
    all[1].rootState.consultantsListVisible = false
    all[1].rootState.phdRegistrationVisible = false
    router.replace(`/${all[1].role}`)
  },
  [MutationTypes.UPDATEPROFILE] (state, data) {
    state.user = data
    state.loadingUserScope = false
  },
  [MutationTypes.SELECTEDROLE] (...all) {
    state.activeRole = all[1].role
    all[1].rootState.showWorkingApplication = false
    all[1].rootState.activeLane = ''
    all[1].rootState.searchedAppHistory = []
    all[1].rootState.assignedApplications = []
    all[1].rootState.workingApplication = {}
    all[1].rootState.showWorkingApplication = false
    state.user = {
      id: all[1].state.user.id,
      name: all[1].state.user.name,
      email: all[1].state.user.email,
      roles: all[1].state.userScope,
      activeRole: all[1].role
    }
    router.replace(`/${all[1].role}`)
  },
  [MutationTypes.LOGIN] (...all) {
    let data = all[1].user
    state.user = User.from(data.access_token)
    state.user.firstname = data.user.firstname
    state.user.name = data.user.name
    state.user.surname = data.user.surname
    state.userFirstname = data.user.firstname
    state.userSurname = data.user.surname
    state.user.email = data.user.email
    state.userScope = state.user.scopes
    state.userScopeGr = state.user.scopes.map(role => dictionary[role])
    state.loadingUserScope = false
    all[1].rootState.startTimer = true
  },
  // [MutationTypes.REFRESHED] (...all) {
  //   let data = all[1].user
  //   state.user = User.from(data.access_token)
  //   state.user.firstname = data.user.firstname
  //   state.user.name = data.user.name
  //   state.user.surname = data.user.surname
  //   state.userFirstname = data.user.firstname
  //   state.userSurname = data.user.surname
  //   state.user.email = data.user.email
  //   state.userScope = state.user.scopes
  //   state.userScopeGr = state.user.scopes.map(role => dictionary[role])
  //   state.loadingUserScope = false
  //   all[1].rootState.startTimer = true
  // },
  [MutationTypes.LOGOUT] (...all) {
    state.user = null
    state.userScope = null
    state.userScopeGr = null
    state.currentUser = null
    state.activeRole = null
    delete sessionStorage.token
    state.loadingUserScope = false
    // remove all assigned and working apps
    all[1].rootState.showWorkingApplication = false
    all[1].rootState.activeLane = ''
    all[1].rootState.searchedAppHistory = []
    all[1].rootState.assignedApplications = []
    all[1].rootState.workingApplication = {}
    all[1].rootState.showWorkingApplication = false
    all[1].rootState.startTimer = false
    all[1].rootState.searchedApps = []
    all[1].rootState.searchVisible = false
    all[1].rootState.searchUniVisible = false
    all[1].rootState.consultantsListVisible = false
    all[1].rootState.phdRegistrationVisible = false
    router.replace('/login')
  }
}
const getters = {
  userNameSurname (state) {
    return state.activeRole != null ? `${state.userFirstname} ${state.userSurname}` : ''
  },
  currentUser (state) {
    return state.activeRole != null ? state.user : null
  },
  isAdmin (state) {
    return state.user && state.user.roles.find(role => role === 'Admin')
  },
  userScope (state) {
    return state.userScope
  },
  userScopeGr (state) {
    return state.userScopeGr
  },
  loadingUserScope (state) {
    return state.loadingUserScope
  },
  activeRole (state) {
    return state.activeRole
  }
}
const actions = {
  updateProfile ({ state, commit, rootState }) {
    state.loadingUserScope = true
    router.replace('/profile')
    axios.get(
      `${config.BASE_URL}/users/${state.user.id}`
    ).then((response) => {
      commit(MutationTypes.UPDATEPROFILE, response.data.data)
    })
  },
  newRole ({ state, commit, rootState }, role) {
    commit(MutationTypes.CHANGEDROLE, {state, role, rootState})
  },
  selectedRole ({ state, commit, rootState }, role) {
    if (role === 'TemporaryUser') {
      Notification.warning({
        title: 'Ειδοποίηση',
        message: 'Παρακαλώ μεταβείτε στο λογαριασμό σας πάνω δεξιά στην επιλογή προφίλ για να αλλάξετε τον κωδικό πρόσβασης σας και να συμπληρώσετε τα στοιχεία σας.',
        offset: 100,
        duration: -1
      })
    }
    commit(MutationTypes.SELECTEDROLE, {state, role, rootState})
  },
  refresh ({ state, commit, rootState }) {
    axios.post(
      `${config.BASE_URL}/login/refresh`,
      {}
    ).then((response) => {
      if (!response.data.data.access_token) {
        this.error = 'Refresh failed!'
        commit(MutationTypes.LOGOUT, { state, commit, rootState })
        return
      }
      sessionStorage.token = response.data.data.access_token
      // this.error = false
      // commit(MutationTypes.REFRESHED, response.data.data)
    }).catch(() => {
      this.error = 'Refresh failed!'
      commit(MutationTypes.LOGOUT, { state, commit, rootState })
    })
  },
  login ({ state, commit, rootState }, {name, password}) {
    if (name !== '' && password !== '') {
      state.loadingUserScope = true
      axios.post(`${config.BASE_URL}/login`,
        { name, password },
        { headers: { 'Content-type': 'application/json' } }
      ).then((response) => {
        if (response.data.data.scope[0] === 'TemporaryUser') {
          Notification.warning({
            title: 'Ειδοποίηση',
            message: 'Παρακαλώ επιλέξτε τον προσωρινό ρόλο.',
            offset: 100,
            duration: 3000
          })
        }
        if (!response.data.data.access_token) {
          this.error = 'Login failed!'
          commit(MutationTypes.LOGOUT, { state, commit, rootState })
          return
        }
        sessionStorage.token = response.data.data.access_token
        this.error = false
        // add if to bypass role selection if there is only one role in scope
        // if (User.from(response.data.data.access_token).scopes.length === 1) {
        //   this.$store.commit(MutationTypes.SELECTEDROLE, User.from(response.data.data.access_token).scopes[0])
        // } else {
        let user = response.data.data
        commit(MutationTypes.LOGIN, { state, user, rootState })
        // }
      }).catch((error) => {
        console.log(error.response.status)
        let title, message
        if (error.response.status === 423) {
          title = 'Κλείδωμα λογαριασμού'
          message = 'Δοκιμάστε ξανά σε 5 λεπτά'
        } else {
          title = 'Λάθος Στοιχεία!'
          message = 'Δεν επιτρέπεται η είσοδος'
        }
        // this.error = 'Login failed!'
        state.loadingUserScope = false
        // alert('asdcsdc')
        Notification.error({
          title: title,
          message: message,
          duration: 3000
        })
        commit(MutationTypes.LOGOUT, { state, commit, rootState })
      })
    }
  },

  logout ({ state, commit, rootState }) {
    return axios.post(
      `${config.BASE_URL}/logout`,
      {}
    ).then((response) => {
      // if (!response.data.access_token) {
      //   this.error = 'Logout failed!'
      //   return
      // }
      this.error = false
      commit(MutationTypes.LOGOUT, { state, response, rootState })
      // commit(MutationTypes.CHANGEDROLE, { state, role, rootState })
    })
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js